<template>
    <div class="MessageContent">
        <v-spacer v-if="!isUser"></v-spacer>
        <div style="background: #fff; border-radius: 5px; text-align: center; max-width: 50%; position: relative; margin-bottom: 12px">
            <v-avatar size="22" color="white" class="react-icon" v-if="react_icon">
              <emoji-parser :emoji="react_icon"/>
            </v-avatar>
            <div class="message-file-slot" :class="{'image-error': imageError}" @click="fileClick">
                <img
                    v-if="checkIfImage(fileName) || fileType==='image'"
                    :src="contentUrl"
                    alt="The content is no longer available."
                    @click="showLightBox()"
                    @error="canNotLoadImage"
                />
                <video v-else-if="isVideo || fileType === 'video'"  autoplay muted>
                  <source :src="contentUrl">
                </video>
                <v-icon v-else size="80">mdi-file</v-icon>
            </div>
            <div v-if="!isVideo" class="message-title" style="text-align: center;padding: 8px;" :title="fileName">
                <a :href="contentUrl" :download="content.file_name">{{ fileName }}</a>
            </div>
        </div>
    </div>
</template>

<script>
import MessageContent from "components/message-box/content/MessageContent";
import staff_service from '../../../services/staff.service';

export default {
    name: "MessageContentFile",
    extends: MessageContent,
    data() {
        return {
            fileName: '',
            contentUrl: '',
            fileType:'',
        }
    },
    mounted() {
        if (this.content.file_provider === 'line' && !this.content.url) {
            let jwt = staff_service.getJwt();
            let bot_code = this.$store.state.bot.code;
            let sender_id = this.$store.state.chatView.customer._id.sender_id;
            if (this.chatlog_id.includes("[ls_render]")) {
                this.contentUrl = `${process.env.VUE_APP_BASE_API_MESSENGER}/live-support/get-line-content/${bot_code}/${sender_id}/${this.content.file_id}/?id_type=file_id&auth_token=${jwt}`
            } else {
                this.contentUrl = `${process.env.VUE_APP_BASE_API_MESSENGER}/live-support/get-line-content/${bot_code}/${sender_id}/${this.chatlog_id}/?id_type=chatlog&auth_token=${jwt}`
            }
            this.fileName = this.content.file_name || this.content.file_type
        } else if(this.content.file_provider === 'instagram' && !this.content.file_name) {
            this.fileType = this.content.file_type;
            this.contentUrl = this.content.url
            this.fileName = "download";
        }
        else {
            this.contentUrl = this.content.url
            if (this.content.url) {
                this.fileName = this.content.file_name || (() => {
                    try {
                        const urlObj = new URL(this.content.url, window.location.origin);
                        const innerUrl = urlObj.searchParams.get('url');
                        if (innerUrl) {
                            return innerUrl.split('/').pop().split('?')[0];
                        }
                        return this.content.url.split('/').pop().split('?')[0];
                    } catch (e) {
                        return this.content.url.split('/').pop().split('?')[0];
                    }
                })();
            }
        }
    },
    computed: {
      isVideo() {
        const videos = ["mp4", "3gp", "ogg"]
        const extension = this.fileName.split(".")[1]
        return videos.includes(extension)
      },
    },
    methods: {
        showLightBox () {
            this.$store.dispatch(this.$ActionTypes.SET_LIGHT_BOX_DATA_THEN_SHOW, {
                data: [
                    {
                        title: this.content.title,
                        description: "",
                        src: this.contentUrl,
                    }
                ],
                index: 0
            });
        },
        checkIfImage (fileName) {
            if (['line', 'google_biz_msg', 'instagram'].includes(this.content.file_provider)) {
                return this.content.file_type === 'image'
            }

            // check image have params
            // 118324519_344777646899344_7689171552145064415_n.jpg?_nc_cat=102&_nc_sid=b96e70&_nc_ohc=qW51MRyVAyQAX9Aj1u6&_nc_ad=z-m&_nc_cid=0&_nc_ht=scontent.xx&oh=bbfc5dd744a938e2f11db1408da693b7&oe=5F6C1CBD
            try {
                if (fileName) {
                    let name_un_params = fileName.split('?')[0];
                    let ext = name_un_params.split('.').pop().toLowerCase();
                    let imageExt = ['tif', 'png', 'gif', 'ico', 'jpg', 'jpeg', 'svg', 'webp'];
                    return imageExt.indexOf(ext) >= 0;
                }
                return false
            } catch (e) {
                return false
            }
        },
        fileClick () {
            if (!this.$isMobile()  && !this.checkIfImage(this.fileName)) {
                window.open(this.contentUrl, '_blank').focus()
            }
        }
    }
}
</script>
<style lang="scss" scoped>
@import "../../style/message-box.scss";
::v-deep.react-icon {
  position: absolute;
  bottom: -10px;
  right: 5px;
}
</style>
